import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../utils/apiBaseQuery";
import { EstablishmentInterface } from "../interfaces/EstablishmentInterface";
import { MetaInterface } from "../interfaces/MetaInterface";
import { ApiEnum } from "../enums/ApiEnum";
import { createQueryString } from "../utils/createQueryString";
import { EstablishmentStatisticsInterface } from "../interfaces/EstablishmentStatisticsInterface";

export const establishmentApiSlice = createApi({
    reducerPath: "establishmentApiSlice",
    baseQuery: apiBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        getEstablishments: builder.query<
            {
                data: EstablishmentInterface[];
                meta?: MetaInterface;
            },
            {
                page?: number;
                items_per_page?: number;
                filter?: {
                    search?: string;
                    employee_id?: number;
                };
            }
        >({
            query: (values) => {
                return {
                    url: `${ApiEnum.ESTABLISHMENT}?${createQueryString(values)}`,
                    method: "GET",
                };
            },
        }),
        getEstablishmentById: builder.query<
            EstablishmentInterface,
            { id: number }
        >({
            query: (values) => {
                return {
                    url: `${ApiEnum.ESTABLISHMENT}/${values.id}`,
                    method: "GET",
                };
            },
        }),
        getEstablishmentStatistics: builder.query<
            EstablishmentStatisticsInterface,
            { id: number }
        >({
            query: (values) => {
                return {
                    url: `${ApiEnum.ESTABLISHMENT}/${values.id}/statistics`,
                    method: "GET",
                };
            },
        }),
        createEstablishment: builder.mutation<
            { data: EstablishmentInterface },
            {
                body: object;
            }
        >({
            query: (values) => ({
                url: ApiEnum.ESTABLISHMENT,
                method: "POST",
                body: values.body,
            }),
        }),
        patchEstablishment: builder.mutation<
            { data: EstablishmentInterface },
            {
                id: number;
                body: object;
            }
        >({
            query: (values) => ({
                url: ApiEnum.ESTABLISHMENT + `/${values.id}`,
                method: "PATCH",
                body: values.body,
            }),
        }),
        deleteEstablishment: builder.mutation<
            { data: EstablishmentInterface },
            { id: number }
        >({
            query: (values) => ({
                url: ApiEnum.ESTABLISHMENT + `/${values.id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export default establishmentApiSlice.reducer;

export const {
    useGetEstablishmentsQuery,
    useGetEstablishmentByIdQuery,
    useCreateEstablishmentMutation,
    usePatchEstablishmentMutation,
    useDeleteEstablishmentMutation,
    useGetEstablishmentStatisticsQuery,
} = establishmentApiSlice;
